import { useAct } from 'FlowBuilder/store'
import './SurveyPageForm.scoped.scss'
import useAnswerTranslate from 'FlowBuilder/hooks/useAnswerTranslate'
import GoalPicker from 'Shared/ScriptEditor/components/GoalPicker'

export default function AnswerForm({ answerId }) {
  const act = useAct()
  const effort = useSel(s => s?.builder?.flow?.effort || s.dashboard?.effort || {})
  const effortName = effort.name || ''
  const goals = effort.goals || []
  const setsGoalId = useSel(s => s.answers.entities[answerId]?.setsGoalId)

  const {
    translated: { answer: answerText },
    fallback: { answer: answerTextFallback },
    textContentUpdater,
    flag
  } = useAnswerTranslate({ answerId });

  return <div className="answer-form">
    <div className='flex-center gap-10'>
      <input className="grow" type='text' value={answerText ?? ''} placeholder={answerTextFallback} onChange={e => textContentUpdater('answer', e.target.value)} />
      <GoalPicker
        goals={goals}
        effortName={effortName}
        setsGoalId={setsGoalId}
        onGoalChange={setsGoalId => act.answers.upsert(answerId, { setsGoalId })}
      />
      <button className="button naked" onClick={() => act.answers.markInactive(answerId)}>
        <SvgIconsCross />
      </button>
      {flag}
    </div>
  </div>
}
